import { Student, Students } from "@/models/Student.js"
import { Schedule, Schedules } from "@/models/Schedule.js"
import firebase, { database } from 'firebase/app'
import { Lesson, Lessons } from "@/models/Lesson"
import { Name } from "@/models/Name"
import { Address } from '@/models/Address'

class StudentRepository {
  constructor(client) {
    this.collection = client.collection("students")
    this.snapShotOptions = { serverTimestamps : 'estimate' }
  }

  async put(
    values
  ) {
    if (!(values.birthday instanceof Date)) {
      throw new TypeError(`The value of birth day must be type of Date. actual: ${typeof values.birthday}`)
    }
    Student.validateGrade(values.birthday)
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const docRef = await this.collection.doc()
    const student = new Student({
      id: docRef.id,
      parentId: values.parentId,
      name: new Name(
        values.personalName,
        values.familyName,
        values.flatPersonalName,
        values.flatFamilyName,
      ),
      gender: values.gender,
      birthday: values.birthday,
      availableSchedules: new Schedules(values.availableSchedules.map(schedule => {
        return new Schedule(
          schedule.day,
          schedule.start,
          schedule.end
        )
      })),
      address: values.address,
      nearestStation: values.nearestStation,
      teacherIds: [],
      lessons: new Lessons([]),
      createdAt: timestamp,
      updatedAt: timestamp
    }
    )
    const object = student.toObject()
    await docRef.set(object.data)
    const result = await docRef.get()
    return createFromFireStoreData(result.id, result.data(this.snapShotOptions))
  }

  async get(id) {
    const result = await this.collection.doc(id).get()
    const data =  result.data(this.snapShotOptions)
    if (data) {
      return createFromFireStoreData(id, data)
    } else {
      throw new Error(`Student: ${id} is not found.`)
    }
  }
  async find(id) {
    return await this.get(id)
  }

  async update(student){
    if (!(student.birthday instanceof Date)) {
      throw new TypeError(`The value of birth day must be type of Date. actual: ${typeof student.birthday}`)
    }
    Student.validateGrade(student.birthday)
    student.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
    const object = student.toObject()
    const docRef = await this.collection.doc(student.id)
    docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createFromFireStoreData(result.id, data)
  }

  async delete(id) {
    return await this.collection.doc(id).delete()
  }

  async query(num) {
    const snapShot = await this.collection.limit(num).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createFromFireStoreData(doc.id, doc.data()))
    })
    return arr
  }

  async collect(uuids) {
    if (!(uuids instanceof Array)) {
      throw new TypeError(`'uuids' must be an instance of Array. Actual: ${typeof uuids}`)
    }
    const arr = await Promise.all(uuids.map(async uuid => {
      return await this.find(uuid)
    }))
    return createStudents(arr)
  }
}

const createFromFireStoreData = (id, data) => {
  return new Student({
    id: id,
    parentId: data.parentId,
    name: new Name(
      data.personalName,
      data.familyName,
      data.flatPersonalName,
      data.flatFamilyName
    ),
    gender: data.gender,
    birthday: data.birthday.toDate(),
    availableSchedules: Schedules.createFromObjects(data.availableSchedules),
    address: new Address(
      data.postalCode,
      data.prefecture,
      data.municipality,
      data.subAddress
    ),
    nearestStation: data.nearestStation,
    teacherIds: data.teacherIds,
    lessons: Lessons.createFromObjects(data.lessons),
    createdAt: data.createdAt.toDate(),
    updatedAt: data.updatedAt.toDate()
  }
  )
}

const createStudents = (arr) => {
  if (!(arr instanceof Array)) {
    throw new TypeError(`'arr' must be an instance of Array. Actual: ${typeof arr}`)
  }
  return new Students(arr)
}

export { StudentRepository }